import {
  Boost,
  Constants,
  Match,
  OnBoardingBits,
  Reaction,
  SubscriptionDiscount,
  Unreads,
  User,
} from '../models';

import {CitiesCountriesDTO} from './CitiesCountriesDTO';
import {LastMatchFavouriteDTO} from './MatchFavouritesDTO';
import {MeDTO} from './MeDTO';
import {ReactionsBaseDTO} from './ReactionsDTO';
import {TrRevisionDTO} from './TrRevisionDTO';

export type HomeVisitsInfo = {
  total_count_visitors: number;
  total_count_visits: number;
};

export type HomeReactionsDTO = ReactionsBaseDTO & {
  positive_sent_total_count: number;
};

export enum LegalDocumentBits {
  none = 0,
  terms_and_conditions = 1,
  privacy_policy = 2,
}

export type Home = MeDTO &
  CitiesCountriesDTO &
  TrRevisionDTO & {
    abtests: string[];
    boost?: Boost;
    constants: Constants;
    match_reaction?: Reaction;
    matches_favourites?: LastMatchFavouriteDTO;
    matches_new: Match[];
    matches_open: Match[];
    onboardings: OnBoardingBits;
    pub_urls_query: string;
    questionnaire_id?: number;
    reactions: HomeReactionsDTO;
    sdo?: SubscriptionDiscount;
    unreads: Unreads;
    updated_legal_documents?: LegalDocumentBits;
    users: User[];
    uuid: string;
    visits: HomeVisitsInfo;
  };
